import React, { useContext, useEffect } from 'react';
import { configuratorContext } from 'context/ConfiguratorContext';
import AuthModalV3 from 'components/Modals/AuthModalV3/AuthModalV3';
import AuthModal from 'components/Modals/AuthModal';
import { AuthModalProps } from 'components/Modals/AuthModal/AuthModal.types';
import useClickStreamEvent from 'utils/clickstream/useClickStreamEvent';

type Props = {
  handleClose: () => void;
  entryPoint: AuthModalProps['entryPoint'];
};

/**
 * Компонент для управления версией модалки авторизации в зависимости от AZ
 * @param variant - версия модалки
 * @param handleClose - функция закрытия модалки
 * @param entryPoint - в контексте модалки - место, откуда вызвано открытие
 */
const AuthModalController = ({ handleClose, entryPoint }: Props) => {
  const { azFromConfigurator } = useContext(configuratorContext);

  const { sendEvent } = useClickStreamEvent();

  const variant = azFromConfigurator?.otvety_auth_variant?.variant || 'default';

  useEffect(() => {
    sendEvent({
      eventType: 'display',
      eventInfo: `otvety_auth_show_${variant}`,
      customDimentions: {
        cd1: JSON.stringify({ source: entryPoint }),
      },
    });
  }, []);

  if (variant === 'fullscreen') {
    return (
      <AuthModalV3
        version={'fullscreen'}
        handleClose={handleClose}
        entryPoint={entryPoint}
      />
    );
  }
  if (variant === 'service') {
    return (
      <AuthModalV3
        version={'service'}
        handleClose={handleClose}
        entryPoint={entryPoint}
      />
    );
  }

  return <AuthModal onClose={handleClose} entryPoint={entryPoint} />;
};

export default AuthModalController;
